import { Injectable } from "@angular/core";
import { AngularFireAuth } from "angularfire2/auth";
import { OAuthService } from "./o-auth/o-auth.service";
import * as firebase from "firebase/app";
import { Observable } from "rxjs/Observable";
import { Subject } from "rxjs/Subject";
import { AngularFireDatabase } from "angularfire2/database";

import "rxjs/add/operator/take";
import { BehaviorSubject } from "rxjs/BehaviorSubject";

@Injectable()
export class MessagingService {
  messaging = firebase.messaging();
  currentMessage = new BehaviorSubject(null);

  constructor(
    private db: AngularFireDatabase,
    private afAuth: AngularFireAuth
  ) {}

  updateToken(token) {
    this.afAuth.authState.take(1).subscribe(user => {
      if (!user) return;

      const data = { [token]: "web" };
      console.log(user);
      return this.db.database
        .ref(`user-push/${user.uid}/token/${token}`)
        .set("web");
      // this.db.path().set("web")
    });
  }

  getPermission() {
    this.messaging
      .requestPermission()
      .then(() => {
        console.log("Notification permission granted.");
        return this.messaging.getToken();
      })
      .then(token => {
        console.log(token);
        return this.updateToken(token);
      })
      .catch(err => {
        console.log("Unable to get permission to notify.", err);
      });
  }

  receiveMessage() {
    this.messaging.onMessage(payload => {
      console.log("Message received. ", payload);
      this.currentMessage.next(payload);
    });
  }
}



// WEBPACK FOOTER //
// D:/Rohit's Project/Golfhubber/golfhubber_club_portal/src/app/services/messaging.service.ts